import {
    CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_REQUEST,
    CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS,
    CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE,

    CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_REQUEST,
    CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS,
    CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterPlateMaterials: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE:
                return []
            default:
                return state
        }
    },
    masterPlateMaterial: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/plateMaterial.js